import { ActionTypes } from "../constants/actionTypes";
export const setActivePage = (page) => {
  return {
    type: ActionTypes.SET_ACTIVE_PAGE,
    payload: page,
  };
};
export const setActiveLanguage = (language) => {
  return {
    type: ActionTypes.SET_ACTIVE_LANGUAGE,
    payload: language,
  };
};
export const setUserCredentials = (credential) => {
  return {
    type: ActionTypes.SET_USER_CREDENTIALS,
    payload: credential,
  };
};
export const setAlert = (alertObj) => {
  return {
    type: ActionTypes.SET_ALERT,
    payload: alertObj,
  };
};
